import React, { useRef } from "react";
import { useEffect } from "react";

export default function CanvasInput({
	active,
	value,
	position,
	onInputChange,
}) {
	const inputRef = useRef();
	const wrapperRef = useRef();

	function onChange(e) {
		updateSize();
		onInputChange(e);
	}

	function updateSize() {
		inputRef.current.style.width =
			inputRef.current.value.length * 10 + 20 + "px";
	}
	function updatePosition() {
		wrapperRef.current.style.left = position.x + "px";
		wrapperRef.current.style.top = position.y + "px";
	}

	useEffect(() => {
		if (active) {
			inputRef.current.focus();
		}
	}, [active, position, value]);

	useEffect(() => {
		updatePosition();
		updateSize();
	}, [position]);

	useEffect(() => {
		if (active) {
			wrapperRef.current.style.opacity = "1";
			inputRef.current.style.pointerEvents = "all";
		} else {
			wrapperRef.current.style.opacity = "0";
			inputRef.current.style.pointerEvents = "none";
		}
	}, [active]);

	return (
		<div className="canvas-input" ref={wrapperRef}>
			<input
				type="text"
				onChange={onChange}
				ref={inputRef}
				value={value}
			/>
		</div>
	);
}
